module.exports = __webpack_public_path__ + "img/Wood-floor-parquet-brown-texture-3d-BPR-free-download-seamless-HD-4K-render-full.70fc80ad.jpg";